import { User } from "@Types/users";
import { createContext } from "react";

const CurrentUserContext = createContext<
  { user?: User; error?: string } | undefined
>(undefined);

export default CurrentUserContext;
